import React from 'react';
import { connect } from 'react-redux';
import { logOut } from '../../actions/auth';
import { Icon } from '../icons';
import { translate } from 'react-i18next';
import './signoutbutton.scss';
import Button from '../layout/Button';

const SignOutButton = ({ t, name, className, onLogOutClick }) =>
  <Button onClick={onLogOutClick} className={className}>
    <div className="sign-out-hover">{t('SIGN_OUT')}, {name}</div>
    <div className="sign-out-icon"><Icon type="exit" /></div>
  </Button>

export default translate('account')(connect(
  ({ currentUser }) => ({
    name: `${currentUser.profile.first_name} ${currentUser.profile.last_name}`
  }),
  dispatch => ({
    onLogOutClick: () => dispatch(logOut())
  })
)(SignOutButton));



// WEBPACK FOOTER //
// ./src/components/containers/SignOutButton.js